var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxAddBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delivery/box-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 18.4669C23 19.2169 22.79 19.9269 22.42 20.5269C22.21 20.8869 21.94 21.2069 21.63 21.4669C20.93 22.0969 20.01 22.4669 19 22.4669C17.78 22.4669 16.69 21.9169 15.97 21.0569C15.95 21.0269 15.92 21.0069 15.9 20.9769C15.78 20.8369 15.67 20.6869 15.58 20.5269C15.21 19.9269 15 19.2169 15 18.4669C15 17.2069 15.58 16.0769 16.5 15.3469C17.19 14.7969 18.06 14.4669 19 14.4669C20 14.4669 20.9 14.8269 21.6 15.4369C21.72 15.5269 21.83 15.6369 21.93 15.7469C22.59 16.4669 23 17.4169 23 18.4669Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4898 18.4468H17.5098",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19 16.9869V19.9769",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.16992 7.9068L11.9999 13.0168L20.77 7.93677",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12 22.0768V13.0068",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.6096 9.63686V15.2969C21.6096 15.3469 21.6096 15.3869 21.5996 15.4369C20.8996 14.8269 19.9996 14.4669 18.9996 14.4669C18.0596 14.4669 17.1896 14.7969 16.4996 15.3469C15.5796 16.0769 14.9996 17.2069 14.9996 18.4669C14.9996 19.2169 15.2096 19.9269 15.5796 20.5269C15.6696 20.6869 15.7796 20.8369 15.8996 20.9769L14.0696 21.9869C12.9296 22.6269 11.0696 22.6269 9.92965 21.9869L4.58965 19.0269C3.37965 18.3569 2.38965 16.6769 2.38965 15.2969V9.63686C2.38965 8.25686 3.37965 6.57688 4.58965 5.90688L9.92965 2.94686C11.0696 2.30686 12.9296 2.30686 14.0696 2.94686L19.4096 5.90688C20.6196 6.57688 21.6096 8.25686 21.6096 9.63686Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxAddBlue);
export default __webpack_public_path__ + "static/media/box-add-blue.a423cae06a5ab4b57c492d828eb37493.svg";
export { ForwardRef as ReactComponent };